import { Constants } from 'utilities/constants';

export type TaskType = 'TODO' | 'IN_PROGRESS' | 'DONE';

export const STATUS_CONFIG: Array<{
  key: TaskType;
  label: string;
  apiStatus: string;
  color: string;
}> = [
  {
    key: 'TODO',
    label: 'To Do',
    apiStatus: 'To Do',
    color: Constants.StatusTask['To Do'],
  },
  {
    key: 'IN_PROGRESS',
    label: 'In Progress',
    apiStatus: 'in progress',
    color: Constants.StatusTask['In Progress'],
  },
  {
    key: 'DONE',
    label: 'Done',
    apiStatus: 'Done',
    color: Constants.StatusTask.Done,
  },
];

export const TABLE_COLUMNS = [
  { id: 'taskName', label: 'Task name', minWidth: 300, align: 'left' as const },
  { id: 'assignee', label: 'Assignee', minWidth: 200, align: 'left' as const },
  { id: 'dueDate', label: 'Due date', minWidth: 150, align: 'left' as const },
  { id: 'priority', label: 'Priority', minWidth: 120, align: 'left' as const },
];

export const headerRowStyles = {
  '& th': { backgroundColor: '#f5f5f5', borderBottom: 'none', padding: '12px' },
  '& th:first-of-type': { borderRadius: '14px 0 0 14px' },
  '& th:last-of-type': { borderRadius: '0 14px 14px 0' },
};

export const STATUS_MAP: Record<string, string[]> = {
  TODO: ['To Do', 'to do', 'TODO', 'Not Started'],
  IN_PROGRESS: ['In Progress', 'in progress', 'IN_PROGRESS'],
  DONE: ['Done', 'done', 'DONE', 'Completed'],
};
